import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Sun, Moon, X, Menu, Zap} from 'lucide-react';
import styles from '../styles/components/Header.module.css';

interface HeaderProps {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

const navItems = [{label: 'Weekly Ranking', href: '/ranking'}, {label: 'Global Ranking', href: '/ranking-global'}];

const Header: React.FC<HeaderProps> = ({darkMode, toggleDarkMode}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    
    onScroll();
    window.addEventListener('scroll', onScroll, {passive: true});
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const ThemeIcon = darkMode ? Sun : Moon;

  return (
    <>
      <header className={styles.navbar}>
        <div className={`${styles.container} ${scrolled ? styles.containerShadow : ''}`}>
          <Link to="/" className={styles.logo}><Zap className={styles.logoIcon} />Arithmetic Blitz</Link>

          <nav className={styles.navLinks}>
            {navItems.map(({label, href }) => (<Link key={label} to={href} className={styles.navLink}>{label}</Link>))}
            <button className={styles.themeToggle} onClick={toggleDarkMode} aria-label="toggle theme"><ThemeIcon className={styles.icon} /></button>
          </nav>

          <div className={styles.actions}>
            <a href="https://apps.apple.com/app/id123456789" target="_blank" rel="noopener noreferrer" className={styles.actionDownload}> Download</a>
            <button className={styles.burger} onClick={() => setMobileOpen(true)} aria-label="open menu"><Menu className={styles.icon} /></button>
          </div>
        </div>
      </header>

      {mobileOpen && (
        <div className={styles.mobileOverlay} onClick={() => setMobileOpen(false)}>
          <button className={styles.overlayClose} aria-label="close menu" onClick={(e) => {e.stopPropagation(); setMobileOpen(false);}}><X className={styles.icon} /></button>
          {navItems.map(({label, href }) => (<Link key={label} to={href} className={styles.navLink} onClick={() => setMobileOpen(false)}>{label}</Link>))}
          <div className={styles.mobileActions}>
            <a href="https://apps.apple.com/app/id123456789" target="_blank" rel="noopener noreferrer" className={styles.mobileDownload}> Download on App Store</a>
            <button className={styles.mobileTheme} onClick={(e) => {e.stopPropagation(); toggleDarkMode();}}>{darkMode ? 'Light mode' : 'Dark mode'}<ThemeIcon size={16} /></button>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;

